let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jTNTf")).then(() => parcelRequire('k7gBp'));